import { FieldValues, UseFormGetValues } from 'react-hook-form'

import {
  getLocalizedSchemaAttributes,
  getLocalizedSchemaEnumValues,
} from './schemaLocalization'
import { SchemaAttributes, SchemaEnumValues } from '@/Data/types'

export const filterDataClassEnumValues = (
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  getValues: UseFormGetValues<FieldValues> | ((key: string) => any),
  enumValues?: SchemaEnumValues[],
  schemaAttributes?: SchemaAttributes,
) => {
  const localizedEnumValues = getLocalizedSchemaEnumValues(enumValues)
  const localizedSchemaAttributes =
    getLocalizedSchemaAttributes(schemaAttributes)
  const watchArray = [
    ...new Set(
      localizedEnumValues?.flatMap((e) =>
        Object.keys(e.constraints ? e.constraints : {}),
      ),
    ),
  ]

  const options = localizedEnumValues?.flatMap((e) => {
    if (!e.constraints) {
      return {
        value: e.value,
        label: e.title,
      }
    }

    const keys = Object.keys(e.constraints)

    return keys.flatMap((key) => {
      if (key === 'isExternal') {
        return { value: e.value, label: e.title }
      }
      if (
        localizedSchemaAttributes?.[key]?.readonly &&
        !localizedSchemaAttributes?.[key]?.mandatory
      ) {
        return { value: e.value, label: e.title }
      }
      if (e.constraints?.[key]?.includes(getValues(key))) {
        return { value: e.value, label: e.title }
      }
      return []
    })
  })

  return { options, watchArray }
}
